import styled from 'styled-components/macro';

import {
  CardHeader,
  CardItem,
  CardLabel,
  CardTitle,
  CardValue,
} from 'common/components/Card/card.styled';

export const Header = styled(CardHeader)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.black_20};
  padding-bottom: 10px;
  margin-bottom: 10px;
`;

export const Title = styled(CardTitle)`
  font-size: ${({ theme }) => theme.fontSize.md};
`;

export const Items = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.zero_2};
`;

export const Item = styled(CardItem)<{ cursor?: string }>`
  justify-content: start;
  padding: ${({ theme }) => theme.spacing.zero};
  gap: ${({ theme }) => theme.spacing.zero_2};
  ${({ cursor }) => cursor && ` cursor: ${cursor}; `}
`;

export const Label = styled(CardLabel)<{ labelColor?: string }>`
  color: ${({ labelColor, theme }) => labelColor || theme.colors.black_70};
  font-size: ${({ theme }) => theme.fontSize.md};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: ${({ theme }) => theme.fontSize.sm};
  }
`;

export const Value = styled(CardValue)<{ valueColor?: string }>`
  ${({ valueColor }) => valueColor && ` color: ${valueColor}; `}
`;
